import Cookies from 'universal-cookie';
import { defaultTheme } from "../constants/themeValues";

const cookies = new Cookies(null, { path: '/' });

export const getThemeInitState = () => {
  const theme = cookies.get('data-theme');
  return theme || defaultTheme
};
